module.exports = __webpack_public_path__ + "img/6x UHF-PS1.c8dc41a9.svg";